export default {
    pageName: 'Approval Inquiry',
    search: {
        title: '',
        placeholder: 'Search by Bureau'
    },
    header: {
        full: 'Bureau',
        sub: 'Bureau'
    }
}
